<template>
  <div class="about">
    <SidebarSite :forceVisible="forceSidebarVisible"></SidebarSite>

    <Header></Header>

    <div class="about-content" v-on:click="closeSidebar">
      <div class="about-content-container">
        <h1>About Powerslide</h1>
        <p>
          Powerslide’s Digital Signage Software is a low cost, cloud-based digital signage app that allows you to easily create, display and manage your content anytime from anywhere.  Powerslide’s digital marketing solution includes:
        </p>

        <ul>
          <li>Content rich digital signage software</li>
          <li>Content customization dashboard</li>
          <li>Professional support services</li>
        </ul>

        <p>
          Any user, even one with limited IT experience can create, display and manage digital signage screens. Using Powerslide’s robust customization dashboard,  you can quickly create dynamic content for your business or institution. <br><br>
          Connect with audiences through a compelling digital marketing experience.  Powerslide provides secure digital signage management software in support of:
        </p>

        <ul>
          <li>Restaurants/Bars/Cafes</li>
          <li>Retail</li>
          <li>Gyms and Fitness</li>
          <li>Banks</li>
          <li>Real Estate</li>
          <li>Entertainment</li>
          <li>Healthcare</li>
          <li>Hospitality</li>
          <li>Education</li>
          <li>Franchises</li>
          <li>Businesses/Corporate Offices</li>
          <li>Places of Worship</li>
          <li>Events</li>
        </ul>

        <p>
          To best serve our customers, Powerslide continues to enhance its digital signage platform in response to customer feedback and as communication requirements evolve.  The sign-up process is simple and self-explanatory and no servers or technical IT support are necessary.
        </p>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import '../styles/base.css'
import Footer from './Footer.vue'
import Header from './Header.vue'
import SidebarSite from './SidebarSite.vue'

export default {
  name: 'About',

  components: {
    Footer,
    Header,
    SidebarSite
  },

  data () {
    return {
      forceSidebarVisible: false
    }
  },

  methods: {
    closeSidebar: function () {
      if (this.forceSidebarVisible) {
        this.forceSidebarVisible = false
      }
    }
  }
}
</script>

<style scoped>
  .about {
    background: var(--contact-bg);
    display: block;
    margin: 0 auto;
    position: relative;
  }

  .about-content {
    margin: 0 auto;
    min-height: calc(100vh - 6em);
    padding: 6em 0;
    width: 100%;
  }

  .about-content-container {
    border: 2px solid var(--light-grey);
    border-radius: 5px;
    margin: 0 auto;
    max-width: 825px;
    padding: 2em;
  }

  h1 {
    margin: 0;
    text-align: center;
  }

  td {
    padding-right: 3em;
    font-weight: 500;
  }

  @media only screen and (max-width: 850px) {
    .about-content-container {
      border: none !important;
      padding: 1em !important;
    }
  }
</style>
